import React from "react";
import { UtensilsCrossed, Gauge, Activity, Brain } from "lucide-react";

const mechanisms = [
  {
    icon: UtensilsCrossed,
    title: "Feel full sooner",
    desc: "Tirzepatide activates GLP‑1 and GIP receptors, reducing appetite and portion sizes naturally.",
    color: "bg-[#E8F0E9] text-[#779D7C]",
  },
  {
    icon: Gauge,
    title: "Slower gastric emptying",
    desc: "Food stays in the stomach longer, so you stay full for hours — not minutes.",
    color: "bg-[#FCE9E2] text-[#B84E38]",
  },
  {
    icon: Activity,
    title: "Better blood sugar",
    desc: "Improves insulin sensitivity and stabilises glucose — a big win if you have prediabetes or T2D.",
    color: "bg-[#E8F3FF] text-[#1E4D8A]",
  },
  {
    icon: Brain,
    title: "Fewer cravings",
    desc: "Dampens food‑noise in the brain's reward pathways, making healthy choices much easier.",
    color: "bg-[#F5ECFF] text-[#5B2E9E]",
  },
];

export const HowItWorks = () => {
  return (
    <section id="how" className="py-24 md:py-32 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-white border border-[#EAE7E1] px-3.5 py-1.5 text-xs font-medium text-[#779D7C]">
              How it works
            </span>
            <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
              The <em className="text-[#EB8771]">science</em> behind Mounjaro.
            </h2>
          </div>
          <p className="max-w-md text-[#38312C] leading-relaxed">
            Tirzepatide is a dual GIP/GLP‑1 receptor agonist — the first of its kind — and works through
            four complementary mechanisms.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {mechanisms.map((m, i) => (
            <div
              key={m.title}
              data-testid={`how-card-${i}`}
              className="rounded-3xl bg-white border border-[#EAE7E1] p-7 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(10,41,32,0.18)] transition-all"
            >
              <div className={`h-11 w-11 rounded-2xl ${m.color} grid place-items-center`}>
                <m.icon className="h-5 w-5" strokeWidth={1.8} />
              </div>
              <p className="font-display text-2xl mt-6 text-[#242220]">{m.title}</p>
              <p className="text-sm text-[#6B6660] mt-2 leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
